export const getFileExtension = (fileName?: string) => {
  const fallback = '未知类型';
  if (!fileName) return fallback;
  const extension = fileName.split('.')?.pop();
  return extension ? extension.toLowerCase() : fallback;
};

export const getFileNameByUrl = (url?: string) => {
  const defaultName = '未知文件';
  if (!url) {
    return defaultName;
  }
  try {
    const paths = url.split('/');
    return paths.at(-1) || defaultName;
  } catch {
    return defaultName;
  }
};

export const formatSize = (sizeInBytes: number): string => {
  const BYTES_IN_KB = 1024;
  const KB_IN_MB = 1024;

  const sizeInKB = sizeInBytes / BYTES_IN_KB;

  if (sizeInKB >= KB_IN_MB) {
    const sizeInMB = sizeInKB / KB_IN_MB;
    return `${sizeInMB.toFixed(2)} M`;
  } else if (sizeInKB >= 1) {
    return `${sizeInKB.toFixed(2)} KB`;
  } else if (sizeInBytes === 0) {
    return '未知';
  } else {
    return `${sizeInBytes} B`;
  }
};

export const supportedPreviewFileType = ['pdf', 'txt', 'docx', 'doc', 'ppt', 'pptx', 'xlsx', 'xls'];

export const isTxtFile = (suffix: string) => suffix === 'txt';
export const isCanOpenFile = (suffix: string) => isPdfFile(suffix) || isTxtFile(suffix);
export const isPdfFile = (suffix: string) => suffix === 'pdf';
// 'docx', 'doc', 'ppt', 'pptx', 'xlsx', 'xls'
export const isOfficeFile = (suffix: string) => ['docx', 'doc', 'xlsx', 'xls'].includes(suffix);
